/**
 * Integracion del informe dentro de otra pagina (iframe).
 *
 * Tres formas de recibir configuracion, por orden de prioridad:
 *   1. postMessage del contenedor: { type: 'ghl-report:config', locationId, token }
 *   2. query string: ?locationId=...&token=...&embed=1&theme=dark
 *   3. variables VITE_* del build / /api/config del proxy
 *
 * Ademas publica su altura al contenedor para que el iframe crezca solo:
 *   { type: 'ghl-report:height', height: 1234 }
 */

export const MSG_CONFIG = 'ghl-report:config'
export const MSG_HEIGHT = 'ghl-report:height'
export const MSG_READY = 'ghl-report:ready'

export function readQueryConfig() {
  const q = new URLSearchParams(window.location.search)
  const get = (...keys) => { for (const k of keys) { const v = q.get(k); if (v) return v } return null }
  return {
    locationId: get('locationId', 'location_id', 'loc'),
    token: get('token', 'apiKey', 'access_token'),
    apiMode: get('mode', 'apiMode'),
    embed: q.get('embed') === '1' || q.get('embed') === 'true' || inIframe(),
    theme: get('theme'),
    pipeline: get('pipeline', 'pipelineId'),
    range: get('range', 'rango'),
    tab: get('tab', 'pestana'),
    stagnantDays: numeric(get('stagnantDays')),
    noActivityDays: numeric(get('noActivityDays')),
  }
}

const numeric = (v) => (v === null || v === '' ? null : Number(v))

export function inIframe() {
  try { return window.self !== window.top } catch { return true }
}

/** Escucha la configuracion que envie el contenedor. */
export function onParentConfig(handler) {
  const listener = (event) => {
    const data = event.data
    if (!data || data.type !== MSG_CONFIG) return
    handler(data, event)
  }
  window.addEventListener('message', listener)
  postToParent({ type: MSG_READY })
  return () => window.removeEventListener('message', listener)
}

export function postToParent(payload) {
  if (!inIframe()) return
  try { window.parent.postMessage(payload, '*') } catch { /* contenedor de otro origen sin permiso */ }
}

/** Publica la altura del documento cada vez que cambia el contenido. */
export function autoResize() {
  if (!inIframe()) return () => {}
  let last = 0
  const send = () => {
    const h = Math.ceil(document.documentElement.scrollHeight)
    if (Math.abs(h - last) < 8) return
    last = h
    postToParent({ type: MSG_HEIGHT, height: h })
  }
  const ro = new ResizeObserver(send)
  ro.observe(document.documentElement)
  window.addEventListener('load', send)
  const timer = setInterval(send, 1000)
  send()
  return () => { ro.disconnect(); clearInterval(timer) }
}
